import { useEffect } from "react";
import { NoSsr } from "@mui/material";
import LiveChatAiButtonStyles from './LiveChatAiButtonStyles';

const liveChatAiEmbedScriptId = 'livechatai-messenger-js'
const liveChatAiEmbedScriptUrl = 'https://app.livechatai.com/embed.js'
const liveChatAiChatbotId = 'cmpmqoi3s00nbjo04v60kvzlq'

interface Props {
  hideOnLabMobile?: boolean
  side?: 'left' | 'right'
  vertical?: 'top' | 'bottom'
}

function applyLiveChatAiIdentity() {
  if (typeof window === 'undefined' || window.APP_LIVECHATAI_IDENTITY === null) {
    return
  }

  window.lc = window.lc ?? {}
  window.lc.identity = window.APP_LIVECHATAI_IDENTITY
}

function loadLiveChatAiScript() {
  if (typeof document === 'undefined') {
    return
  }

  applyLiveChatAiIdentity()

  if (document.getElementById(liveChatAiEmbedScriptId) !== null) {
    return
  }

  const script = document.createElement('script')
  script.id = liveChatAiEmbedScriptId
  script.src = liveChatAiEmbedScriptUrl
  script.dataset.id = liveChatAiChatbotId
  script.async = true
  script.defer = true

  document.body.appendChild(script)
}

export default function LiveChatAiMessenger(props: Props) {
  useEffect(() => {
    loadLiveChatAiScript()
  }, [])

  return <NoSsr>
    <LiveChatAiButtonStyles
      hideOnLabMobile={props.hideOnLabMobile}
      side={props.side}
      vertical={props.vertical}
    />
  </NoSsr>
}
